<template>
  <div
    v-if="hasDocuments"
    class="traceability-documents"
  >
    <div class="traceability-icons">
      <div
        v-if="hasMtr"
        class="traceability-icon-block"
      >
        <div class="traceability-icon-wrap">
          <v-icon
            size="36"
            color="primary"
          >
            mdi-file-document-outline
          </v-icon>
          <v-icon
            class="traceability-check"
            size="16"
            color="primary"
          >
            mdi-check-circle
          </v-icon>
        </div>
        <span class="traceability-icon-label">MTR</span>
      </div>

      <span
        v-if="hasMtr && hasCdf"
        class="traceability-plus"
      >+</span>

      <div
        v-if="hasCdf"
        class="traceability-icon-block"
      >
        <div class="traceability-icon-wrap">
          <v-icon
            size="36"
            color="primary"
          >
            mdi-file-document-outline
          </v-icon>
          <v-icon
            class="traceability-check"
            size="16"
            color="primary"
          >
            mdi-check-circle
          </v-icon>
        </div>
        <span class="traceability-icon-label">CDF</span>
      </div>
    </div>

    <div class="traceability-content">
      <h3 class="traceability-title">
        {{ title }}
      </h3>
      <p class="traceability-description">
        {{ $t('components.offered.card_offered.traceability.description') }}
      </p>
      <div class="traceability-pills">
        <span
          v-if="hasMtr"
          class="traceability-pill"
        >
          <v-icon
            size="14"
            color="primary"
          >
            mdi-check
          </v-icon>
          {{ $t('components.offered.card_offered.traceability.mtr_linked') }}
        </span>
        <span
          v-if="hasCdf"
          class="traceability-pill"
        >
          <v-icon
            size="14"
            color="primary"
          >
            mdi-check
          </v-icon>
          {{ $t('components.offered.card_offered.traceability.cdf_linked') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TraceabilityDocuments',
  props: {
    hasMtr: {
      type: Boolean,
      default: false,
    },
    hasCdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasDocuments() {
      return this.hasMtr || this.hasCdf;
    },
    documentsLabel() {
      const parts = [];
      if (this.hasMtr) parts.push('MTR');
      if (this.hasCdf) parts.push('CDF');
      return parts.join(' + ');
    },
    title() {
      return this.$t('components.offered.card_offered.traceability.title', {
        documents: this.documentsLabel,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.traceability-documents {
  display: flex;
  align-items: center;
  gap: 28px;
  width: 100%;
  padding: 20px 24px;
  border-radius: 10px;
  background: $dashboard_background;
  pointer-events: none;
  user-select: none;
}

.traceability-icons {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.traceability-icon-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.traceability-icon-wrap {
  position: relative;
  display: inline-flex;
}

.traceability-check {
  position: absolute;
  right: -4px;
  bottom: -2px;
  background: $color_white;
  border-radius: 50%;
}

.traceability-icon-label {
  font-size: 0.75em;
  font-weight: 700;
  color: $color_primary;
}

.traceability-plus {
  font-size: 1.25em;
  font-weight: 700;
  color: $color_primary;
  margin-bottom: 16px;
}

.traceability-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.traceability-title {
  margin: 0;
  font-size: 1em;
  font-weight: 700;
  color: $color_dark;
}

.traceability-description {
  margin: 0;
  font-size: 0.875em;
  color: $color_gray;
}

.traceability-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.traceability-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid $color_primary;
  border-radius: 999px;
  font-size: 0.75em;
  font-weight: 600;
  color: $color_primary;
  background: $color_white;
}
</style>
